<!-- 查询模板 -->
<template>
    <div class="container">
        <Table :columns="columnTable" :data="dataTable" border>
            <template slot-scope="{ row }" slot="cover_img">
                <div class="flex-c">
                    <div class="tooltip-div">
                        <Tooltip v-if="row.cover_img" theme="light" transfer>
                            <img class="wh37 cursor-p" :src="row.cover_img" />
                            <template slot="content">
                                <img class="wh200" :src="row.cover_img" />
                            </template>
                        </Tooltip>
                    </div>
                </div>
            </template>
            <template slot-scope="{ row }" slot="operate">
                <div class="flex-sa">
                    <Button
                        v-if="row.merchant_query_template_id"
                        type="warning"
                        ghost
                        @click="linkDiy(row)"
                        >编辑</Button
                    >
                    <Button v-if="!row.merchant_query_template_id" type="primary" ghost @click="goUse(row)"
                        >使用</Button
                    >
                </div>
            </template>
        </Table>
        <div class="ta-r mt24">
            <Page
                :current="storePrams.page"
                :page-size="storePrams.limit"
                :total="total"
                show-elevator
                show-total
                @on-change="pageChange"
            />
        </div>
    </div>
</template>

<script>
import { template_query_template, template_modify_use } from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnTable: [
                { type: "index", width: 60, align: "center" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "预览图", slot: "cover_img", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "250px",
                },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        getList() {
            template_query_template(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.list;
                    this.total = res.data.count;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Page
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 使用
        goUse(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确定要使用此模板（" + row.title + "）？",
                onOk: () => {
                    template_modify_use({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                            this.$router.push({
                                path: `/admin/formwork/editDiy?id=${row.id}&diy_id=2`,
                            });
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // 跳转DIY
        // diy_id == 2（查询模板）
        linkDiy(row) {
            this.$router.push({
                path: `/admin/formwork/editDiy?id=${row.id}&diy_id=2`,
            });
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.tooltip-div {
    margin: 12px;
    padding-top: 3px;
    width: 60px;
    height: 60px;
    background: #fbfbfb;
    border: 1px solid #eaeaea;
}
.wh37 {
    width: 37px;
    height: 54px;
}
.wh200 {
    width: 200px;
    height: 375px;
}
.w54 {
    width: 54px;
}
.ta-r {
    text-align: right;
}
.cursor-p {
    cursor: pointer;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>